import React, { Component, createRef, Fragment } from "react";
import {
  Hero,
  Title,
  TechniqueTitle,
  ClientTag,
  CaseWrapper,
  BackButton,
  BackArrow
} from "../styles/Case.styles";

import Reveal from 'react-reveal/Reveal';
import { withRouter } from "react-router";
import Footer from '../components/Footer';
import { Efectr, Efectr1, Efectr2  } from "../styles/effect.styles";

export const ScrollTop = ({ children, location }) => {
  React.useEffect(() => window.scrollTo(0, 0), [location])
  return children
}

class Case extends Component {
  constructor(props) {
    super(props);
    this.introRef = createRef();

    this.state = {
          toBack: false,
          introTop: 0,
          hasBackground: false,
          animateCase: ""
        };
      }
    
      componentDidUpdate() {
        if (this.state.toBack) {
          setTimeout(() => {
            this.props.setNavBackground(false);
            this.props.history.push("/blog");
          }, 400);
        }
        if (this.state.animateCase) {
          setTimeout(() => {
            this.props.setNavBackground(false);
    
            this.props.history.push(this.state.animateCase);
            window.scrollTo(0, 0);
          }, 400);
        }
      }
    
    
      render() {
        return (
          <Fragment>
          <Efectr/>
          <Efectr1/>
          <Efectr2/>
          <ScrollTop>
            <CaseWrapper>
              <Reveal effect="fadeIn">
                <Hero className='mainhero' style={{ backgroundImage: "url('./img/news/MigraineLrg.jpg')" }}>
                    <div className='herocaption'>
                      <BackButton className='backdetail'
                        onClick={() => this.setState({ toBack: true, hasBackground: false })}
                        toBack={this.state.toBack}
                        hasBackground={this.state.hasBackground}>
                        <BackArrow src="./img/back.png" alt="Back to blog" />
                        <span>Back </span>
                      </BackButton>
                      <div className='container'>
                        <div className='row'>
                          <div className='col-md-12 pl-md-0'>
                            <ClientTag className='date'>April 15, 2024</ClientTag>
                            <Title>Migraine</Title>
                            <TechniqueTitle>
                            More than just a bad headache
                            </TechniqueTitle>
                          </div>
                        </div>
                      </div>
                    </div>
                </Hero>
              </Reveal>
    
              <section className='container' id='detailproject'>
                <div className='row'>
                  <div className='col-md-12'>
                    <p className='content'>Ever felt like your head was staging a drum solo? That intense, throbbing, one-sided headache coupled with nausea and sensitivity to light? Bingo, that's a migraine! And guess what? You're not alone. Around 20% of adults experience these head- pounders, with the party starting as early as age 5 and hitting its peak between 25 and 35. Migraines are even more common among individuals with metabolic disorders due to increases in sodium, glucose, and carbon dioxide within the blood in addition to poor waste elimination.</p>
                    <p className='content'>There is an intricacy of factors behind migraines from genetics to environmental triggers and brain chemistry. It is a complex mix, with everything from stress to certain foods or weather patterns potentially joining the migraine party. </p>
                     <p className='content'> But fear not! Whether you are navigating though the constant stimulation of modern life or dodging migraine-triggering ingredients, there is a path to relief. Understanding your unique triggers can be key to managing and preventing future attacks, either through lifestyle adjustments, natural remedies, or even medical interventions.</p>

                  
                    <h3 className='my-5'>Ways to Minimize Migraine Symptoms</h3>
                    <div>
                      <p className='content'>1. Diet modifications: Diets that have shown to be useful in preventing and managing migraines are: Ketogenic, Low glycemic, and Elimination. </p>
                      <p className='content'> 2. Avoid common food triggers: such as; bananas, beans, chocolate, onions, corn, tomatoes, alcohol. </p>
                      <p className='content'>3. Avoid common food additive triggers:
                      aspartame, nitrates & nitrites, MSG, and caffeine. </p>
                      <p className='content'> 4. Environment: Allow yourself 30 minutes of natural light daily for migraine prevention </p>
                      <p className='content'>5.Supplements: Magnesium, Riboflavin, CoQ10, Vitamin D, Alpha lipoic acid, Feverfew, Butterbur</p>
                      <p className='content'>6. Expert help: Speak with your naturopathic doctor to customize a migraine protocol specific for you! </p>
                    </div>
                  </div>  

                  <div className='col-md-12'></div>
                  <div className='share'>
                    <span className='heading'>
                    Share this blog post :
                    </span>
                    <span className='content'> 
                    <a href="https://www.facebook.com/sharer/sharer.php?u=drmichellemaliknd.com/WOW5" target="_blank" rel="noopener noreferrer">  
                      <i className="fa fa-facebook-f"></i>
                      </a>  
                    </span>
                    <span className='content'> 
                    <a href="https://www.instagram.com/dr.michellemalik.nd" target="_blank" rel="noopener noreferrer">   
                      <i className="fa  fa-instagram"></i>
                      </a>
                    </span>
                  </div>
                </div>
              </section>

            </CaseWrapper>
    
          </ScrollTop>
    
          <Footer />
    
          </Fragment>
        );
      }
    }
    
    export default withRouter(Case);